module.exports = __webpack_public_path__ + "media/bootstrap-icons/asterisk-eefae929.svg";